import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import RechargeAmountForm from '../../../../Componant/Application/Project/master/RechargeAmountForm'


const RechargeContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <RechargeAmountForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default RechargeContainer